import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  // 30 minutes in seconds
  const INITIAL_TIME = 30 * 60;
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          return INITIAL_TIME;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="font-mono font-bold text-xl tracking-widest text-white bg-red-600 px-3 py-1 rounded inline-block" data-id="element-31">
      {minutes.toString().padStart(2, '0')}:
      {seconds.toString().padStart(2, '0')}
    </div>;
}